import { render, staticRenderFns } from "./StudioProduct.vue?vue&type=template&id=4d2dbdc3&scoped=true&"
import script from "./StudioProduct.vue?vue&type=script&lang=js&"
export * from "./StudioProduct.vue?vue&type=script&lang=js&"
import style0 from "./StudioProduct.vue?vue&type=style&index=0&id=4d2dbdc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2dbdc3",
  null
  
)

component.options.__file = "StudioProduct.vue"
export default component.exports